<template>
  <section class="mt-8 mx-5">
    <div id="rectangle1"></div>
    <div id="rectangle2"></div>
    <!-- <div id="rectangle3"></div>
    <div id="rectangle4"></div> -->
    <div id="rectangle5"></div>
    <IconoHeaderPuntual class="index1" />
    <div class="index1 d-flex flex-column justify-center align-center">
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-color texto-titulo text-center font-weight-bold">
            BIENVENID{{
              $store.getters['persona/obtenerGeneroPersona'] == 'H' ? 'O' : 'A'
            }}
            <!-- SOCI{{
              $store.getters['persona/obtenerGeneroPersona'] == 'H' ? 'O' : 'A'
            }}
            PUNTUAL -->
            {{ persona.nombreBienvenida.toUpperCase() }}
            DISFRUTA LA NUEVA EXPERIENCIA DIGITAL
            <!-- <span class="text-capitalize">{{ persona.nombreBienvenida }}</span> -->
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <img
          :src="ObtenerLogo"
          alt="logo"
          class="imageActiva d-flex flex-row justify-space-between align-center"
        />
        <v-col cols="12" class="mt-14 ma-0 pa-0">
          <p
            class="
              texto-titulo
              text-center
              texto-color
              text--darken-2
              ma-0
              mx-3
            "
          >
            ¡Sin filas y sin papeleo desde cualquier lugar!
          </p>
        </v-col>
      </v-row>
      <!-- <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="mt-0 ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            v-bind="attrs"
            v-on="on"
            elevation="3"
            @click="comenzar"
            >Comenzar<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row> -->
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-dialog v-model="dialogDocumentos" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="quitarClases"
                >Comenzar<v-icon right light>mdi-arrow-right</v-icon></v-btn
              >
              <!-- <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="noInteresado"
                >NO INTERESADO DE MOMENTO<v-icon right light
                  >mdi-arrow-left</v-icon
                ></v-btn
              > -->
            </template>
            <v-card class="ma-0 pa-0" cols="5">
              <v-card-title>Antes de comenzar...</v-card-title>
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >Validaremos tu télefono celular
                <v-chip color="green" outlined>{{ celularOferta }} </v-chip>
                enviando un código de verificación:</v-card-subtitle
              >
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >No olvides tener a la mano los documentos que necesitarás
                durante el proceso:</v-card-subtitle
              >
              <v-list disabled class="ma-0 px-3">
                <v-list-item-group color="primary">
                  <v-list-item
                    class="v-item--active v-list-item--active my-2"
                    v-bind:class="{ 'v-list-item__title': false }"
                    v-for="(item, i) in documentosNecesarios"
                    :key="i"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon v-text="item.icono"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-bold"
                        v-text="item.texto"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-card-actions class="d-flex flex-row justify-end">
                <v-btn
                  @click="continuarAPArametrizacion"
                  :loading="cargando"
                  :disabled="cargando"
                  elevation="2"
                  color="primary"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-7 mb-2 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p class="text-center white--text text--darken-2 ma-0">
            ¿Dudas sobre nuestro nuevo producto? Contáctanos via Whatsapp o al
            telefono
            <a href="tel:8003000268" style="color: lightgreen"
              ><br />
              800-3000-268</a
            >
            <!-- <br />800-3000-268<br /> -->
            <!-- <router-link
            :to="{ name: 'cancelacion' }"
            class="text-body-30 font-weight-bold"
            >Haz click aqui</router-link
          > -->
          </p>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-0 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="5" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            v-bind="attrs"
            v-on="on"
            elevation="3"
            @click="whats"
            >Mensaje<v-icon right light>mdi-whatsapp</v-icon></v-btn
          >
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="5" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            v-bind="attrs"
            v-on="on"
            elevation="3"
            @click="llamar"
            >Llamar<v-icon right light>mdi-phone</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import IconoHeaderPuntual from '@/components/compartidos/IconoHeaderPuntual.vue'
import OtpService from '@/servicios/otp'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: { IconoHeaderPuntual },
  mixins: [InsertaLogMixin],
  name: 'BienvenidaConfianzaSPD',
  data: () => ({
    dialogDocumentos: false,
    documentosNecesarios: [],
    persona: '',
    tipoPersona: null,
    cargando: false,
    celularOferta: '',
  }),
  created() {
    this.persona = this.$store.getters['persona/obtenerPersona'].datosPersonales
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
    this.celularOferta = this.$store.getters['persona/obtenerCelularOferta']
    this.$gtag.event('telefonoOferta', {
      event_category: 'Enter Page',
      event_label: 'Celular de la oferta',
      value: this.celularOferta,
    })
    this.InsertaLog({ notas: 'Celular de la oferta ' + this.celularOferta })
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.documentosNecesarios =
      this.$store.getters['personaDocumentos/obtenerDocumentosASolicitar']
  },
  computed: {
    ObtenerLogo() {
      return require('@/assets/images/spd.png')
    },
  },
  methods: {
    comenzar() {
      // this.$router.push('Bienvenida')
      // this.$emit('comenzar')
      this.dialogDocumentos = true
    },
    whats() {
      // window.location.href = 'https://wa.me/5215510695948'
      window.open('https://wa.me/5215510695948', '_blank')
    },
    llamar() {
      // window.location.href = 'tel:8003000268'
      window.open('tel:8003000268', '_blank')
    },
    async quitarClases() {
      //documento multilinea
      try {
        setTimeout(() => {
          while (
            document.getElementsByClassName('v-list-item__title').length > 0
          ) {
            document
              .getElementsByClassName('v-list-item__title')[0]
              .classList.remove('v-list-item__title')
          }
        }, 50)
      } catch (error) {
        console.error(error)
      }
    },
    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      let result
      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          result.data.Mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    async continuarAVerificacionOtp() {
      await this.enviarOtp()
      this.$router.push('verificacion-otp')
    },
    continuarAPArametrizacion() {
      this.$router.push('parametrizacion')
    },
  },
}
</script>
<style scoped>
@media screen and (max-width: 500px) {
  #rectangle1 {
    width: 580px;
    height: 200px;
    background: #c99802;
    position: absolute;
    top: -70px;
    left: -180px;
    transform: rotate(155deg);
    z-index: 1;
    box-shadow: 0px -2px 5px black;
  }
  #rectangle2 {
    width: 1000px;
    height: 910px;
    background: white !important;
    position: absolute;
    top: 0px;
    left: -68%;
    transform: rotate(180deg);
    z-index: 0;
    box-shadow: 0px -2px 5px black;
  }
  #rectangle3 {
    width: 150px;
    height: 120px;
    background: white !important;
    position: absolute;
    top: 325px; /*35%;*/
    left: 35%;
    transform: rotate(155deg);
    z-index: 0;
    /* box-shadow: 0px -2px 5px black; */
  }
  #rectangle4 {
    width: 450px;
    height: 120px;
    background: white !important;
    position: absolute;
    top: 267px; /*28%;*/
    left: 58%;
    transform: rotate(155deg);
    z-index: 0;
    /* box-shadow: 0px -2px 5px black; */
  }
  #rectangle5 {
    width: 650px;
    height: 180px;
    background: #c99802;
    position: absolute;
    top: 630px; /*70%;*/
    left: -15%;
    transform: rotate(165deg);
    z-index: 0;
    box-shadow: 0px -2px 5px black;
  }
  .texto-color {
    color: black;
  }
}
.index1 {
  z-index: 1;
  position: relative;
}
@media screen and (min-width: 501px) and (max-width: 1001px) {
  .texto-color {
    color: black;
  }

  #rectangle5 {
    width: 95%;
    height: 95%;
    background: white !important;
    position: fixed;
    z-index: 0;
    top: 2%;
    /* left: -4%; */
    box-shadow: 0px -2px 5px black;
  }
}
.imageActiva {
  height: 125px;
}
/* .imageAnimate {
  animation-name: example;
  animation-duration: 20s;
  position: absolute;
  display: none;
}
@keyframes example {
  from {
    top: 0px;
  }
  to {
    top: 700px;
  }
} */
</style>
